export default __webpack_public_path__ + "static/Montserrat-Light-e1904bddf85569b4261c73c9a6e80787.ttf";